import { render, staticRenderFns } from "./TrainingIndex.vue?vue&type=template&id=adce7ab4&scoped=true"
import script from "./TrainingIndex.vue?vue&type=script&lang=js"
export * from "./TrainingIndex.vue?vue&type=script&lang=js"
import style0 from "./TrainingIndex.vue?vue&type=style&index=0&id=adce7ab4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adce7ab4",
  null
  
)

export default component.exports